import { mark } from '../../adaptor';
import { flow, transformOptions } from '../../utils';
/**
 * @param chart
 * @param options
 */
export function adaptor(params) {
    return flow(mark, transformOptions)(params);
}
